// extracted by mini-css-extract-plugin
module.exports = {"smartDevicesTreaserA":"A_smartDevicesTreaserA__spGF_"};